import React from "react";
import { Gem, ShieldCheck, Truck, RotateCcw } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { whyChooseUs } from "@/config/brand";

const ICONS = { gem: Gem, "shield-check": ShieldCheck, truck: Truck, "rotate-ccw": RotateCcw };

export function WhyChooseUs() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {whyChooseUs.map((f, i) => {
          const Icon = ICONS[f.icon] || Gem;
          return (
            <Reveal key={f.title} delay={i * 0.08}>
              <div className="flex flex-col items-center border border-border bg-white/50 px-6 py-10 text-center transition-colors hover:border-gold/40">
                <span className="grid h-14 w-14 place-items-center rounded-full bg-gold-light text-gold">
                  <Icon size={24} strokeWidth={1.4} />
                </span>
                <h3 className="mt-5 font-serif text-xl text-ink">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{f.description}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
